import styles from './QueryPlatform.module.css';
import { tiktokIcon, youtubeIcon, instagramIcon } from '../assets/images/social-icons';
import { useQuery } from '../QueryContext';

const QueryPlatform = ({ onPlatformChange }) => {
  const { selectedPlatform, setSelectedPlatform } = useQuery();

  const handlePlatformClick = (platform) => {
    setSelectedPlatform(platform);
    if (onPlatformChange) {
      onPlatformChange(platform);
    }
  };

  return (
    <div className={styles.frameParent}>
      <div className={styles.platformWrapper}>
        <b className={styles.platform}>Platform:</b>
      </div>
      <div
        className={`${styles.assistiveChip} ${
          selectedPlatform === 'tiktok' ? styles.selected : ''
        }`}
        onClick={selectedPlatform === 'tiktok' ? null : () => handlePlatformClick('tiktok')}
        style={{
          cursor: selectedPlatform === 'tiktok' ? 'default' : 'pointer'
        }}
      >
        <div className={styles.stateLayer}>
          <div className={styles.socialIcons}>
            <img className={styles.vectorIcon} alt="TikTok" src={tiktokIcon} />
          </div>
          <div className={styles.labelText}>TikTok</div>
        </div>
      </div>
      <div
        className={`${styles.assistiveChip} ${
          selectedPlatform === 'youtube' ? styles.selected : ''
        }`}
        onClick={selectedPlatform === 'youtube' ? null : () => handlePlatformClick('youtube')}
        style={{
          cursor: selectedPlatform === 'youtube' ? 'default' : 'pointer'
        }}
      >
        <div className={styles.stateLayer}>
          <div className={styles.socialIcons}>
            <img className={styles.vectorIcon} alt="YouTube" src={youtubeIcon} />
          </div>
          <div className={styles.labelText}>YouTube</div>
        </div>
      </div>
      <div
        className={`${styles.assistiveChip} ${
          selectedPlatform === 'instagram' ? styles.selected : ''
        }`}
        onClick={selectedPlatform === 'instagram' ? null : () => handlePlatformClick('instagram')}
        style={{
          cursor: selectedPlatform === 'instagram' ? 'default' : 'pointer'
        }}
      >
        <div className={styles.stateLayer}>
          <div className={styles.socialIcons}>
            <img className={styles.vectorIcon} alt="Instagram" src={instagramIcon} />
          </div>
          <div className={styles.labelText}>Instagram</div>
        </div>
      </div>
    </div>
  );
};

export default QueryPlatform;
